import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

import type { ComputedRef } from 'vue'
	import { reactive, computed, watch } from 'vue'
	import { useGeneral } from '@/hooks'

	
export default /*#__PURE__*/_defineComponent({
  props: {
		modelValue: { type: String },
		items: { type: Array, default: () => [], required: true }
	},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: $emit }) {

const $props = __props

	const { $t, density } = useGeneral()

	
	

	// const state = reactive({
	// 	tab: '',
	// 	component: 0
	// })
	const items: ComputedRef = computed(() => $props.items)

	// watch(
	// 	() => $props.modelValue,
	// 	() => init()
	// )

	// function init() {
	// 	if ($props.modelValue) {
	// 		console.log(`🚀 ~ init ~ $props.modelValue`, $props.modelValue)
	// 		state.tab = $props.modelValue
	// 		state.component++
	// 	}
	// }
	// init()

	function onChange(val: any) {
		// $emit('update:modelValue', val)
		$emit('change', val)
	}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!

  return (_openBlock(), _createBlock(_component_v_tabs, {
    modelValue: $props.modelValue,
    density: _unref(density),
    color: "primary",
    "slider-color": "success"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item, idx) => {
        return (_openBlock(), _createBlock(_component_v_tab, {
          key: idx,
          value: item.value,
          disabled: item.disabled,
          class: _normalizeClass({ 'text-primary': !item.disabled }),
          "selected-class": "v-tab--selected text-success",
          onClick: ($event: any) => (onChange(item.value))
        }, {
          default: _withCtx(() => [
            (item.icon && $props.modelValue === item.value)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  icon: item.icon,
                  class: "mr-4"
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_unref($t)(item.text)), 1)
          ]),
          _: 2
        }, 1032, ["value", "disabled", "class", "onClick"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "density"]))
}
}

})